export class AbstraktniSoubor {
	nazev: string;
	velikost: number;
	data: string;
}
